import { render, staticRenderFns } from "./CorporateKits.vue?vue&type=template&id=b5b1d948&"
import script from "./CorporateKits.vue?vue&type=script&lang=js&"
export * from "./CorporateKits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports